import { render, staticRenderFns } from "./PriceRangeUnits.vue?vue&type=template&id=3f3905c8&scoped=true"
import script from "./PriceRangeUnits.vue?vue&type=script&lang=js"
export * from "./PriceRangeUnits.vue?vue&type=script&lang=js"
import style0 from "./PriceRangeUnits.vue?vue&type=style&index=0&id=3f3905c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3905c8",
  null
  
)

export default component.exports